import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AuthPage from "../pages/auth/page";
import DonatePage from "../pages/donate/page";
import FarmPage from "../pages/farm/page";
import CommunityPage from "../pages/community/page";
import ProfilePage from "../pages/profile/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/auth",
    element: <AuthPage />,
  },
  {
    path: "/donate",
    element: <DonatePage />,
  },
  {
    path: "/farm",
    element: <FarmPage />,
  },
  {
    path: "/community",
    element: <CommunityPage />,
  },
  {
    path: "/profile",
    element: <ProfilePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
